import { BaseQuestionnaireRoute } from '../slice';

export type CorporationSubRoutes = {
  usCorpOrPartnership: BaseQuestionnaireRoute;
  nonUsCorpOfPartnership: BaseQuestionnaireRoute;
  usTrust: BaseQuestionnaireRoute;
  nonUsTrust: BaseQuestionnaireRoute;
};

export type CorporationTrustRoutes = BaseQuestionnaireRoute &
  CorporationSubRoutes;

export const corporationTrustRoutes: {
  corporationTrust: CorporationTrustRoutes;
} = {
  corporationTrust: {
    title: 'Corporation Trust',
    path: 'corporationTrust',
    isValid: undefined,
    usCorpOrPartnership: {
      title: 'US Corp Or Partnership',
      path: 'usCorpOrPartnership',
      isValid: undefined,
    },
    nonUsCorpOfPartnership: {
      title: 'Non US Corp Or Partnership',
      path: 'nonUsCorpOfPartnership',
      isValid: undefined,
    },
    usTrust: {
      title: 'US Trust',
      path: 'usTrust',
      isValid: undefined,
    },
    nonUsTrust: {
      title: 'Non US Trust',
      path: 'nonUsTrust',
      isValid: undefined,
    },
  },
};
